import PropTypes from 'prop-types';
import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  CircularProgress,
  InputLabel,
  OutlinedInput,
  Typography,
  InputAdornment,
  Select,
  MenuItem,
  FormLabel,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  List,
  FormGroup,
  FormControlLabel,
  Switch,
  Autocomplete,
  TextField,
  Chip
} from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { useTheme } from '@mui/material/styles';
import { gridSpacing } from 'store/constant';
import { Form, FieldArray } from 'formik';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
// import Switch from '@mui/material/Switch';
// import FormGroup from '@mui/material/FormGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';
import CheckIcon from '@mui/icons-material/Check';

import {
  ColorPicker
  // useColor
} from 'react-color-palette';
import 'react-color-palette/css';
import { Fragment } from 'react';
import { useGetOrganizationNewAllList } from 'hooks/useOrganizationNewHooks';

const currencyArray = [
  { Currency: 'United States dollar', Code: 'USD', Symbol: '$' },
  { Currency: 'Australian dollar', Code: 'AUD', Symbol: 'A$' },
  { Currency: 'Brazilian real', Code: 'BRL', Symbol: 'R$' },
  { Currency: 'Canadian dollar', Code: 'CAD', Symbol: 'C$' },
  { Currency: 'Chinese Renmenbi', Code: 'CNY', Symbol: '¥' },
  { Currency: 'Czech koruna', Code: 'CZK', Symbol: 'Kč' },
  { Currency: 'Danish krone', Code: 'DKK', Symbol: 'kr' },
  { Currency: 'Euro', Code: 'EUR', Symbol: '€' },
  { Currency: 'Hong Kong dollar', Code: 'HKD', Symbol: 'HK$' },
  { Currency: 'Hungarian forint', Code: 'HUF', Symbol: 'Ft' },
  { Currency: 'Israeli new shekel', Code: 'ILS', Symbol: '₪' },
  { Currency: 'Japanese yen', Code: 'JPY', Symbol: '¥' },
  { Currency: 'Malaysian ringgit', Code: 'MYR', Symbol: 'RM' },
  { Currency: 'Mexican peso', Code: 'MXN', Symbol: 'Mex$' },
  { Currency: 'New Taiwan dollar', Code: 'TWD', Symbol: 'NT$' },
  { Currency: 'New Zealand dollar', Code: 'NZD', Symbol: 'NZ$' },
  { Currency: 'Norwegian krone', Code: 'NOK', Symbol: 'kr' },
  { Currency: 'Philippine peso', Code: 'PHP', Symbol: '₱' },
  { Currency: 'Polish złoty', Code: 'PLN', Symbol: 'zł' },
  { Currency: 'Pound sterling', Code: 'GBP', Symbol: '£' },
  { Currency: 'Russian ruble', Code: 'RUB', Symbol: '₽' },
  { Currency: 'Singapore dollar', Code: 'SGD', Symbol: 'S$' },
  { Currency: 'Swedish krona', Code: 'SEK', Symbol: 'kr' },
  { Currency: 'Swiss franc', Code: 'CHF', Symbol: 'CHF' },
  { Currency: 'Thai baht', Code: 'THB', Symbol: '฿' }
];

const SubscriptionForm = ({
  errors,
  handleBlur,
  handleChange,
  handleSubmit,
  // isSubmitting,
  touched,
  values,
  setFieldValue,
  isSubscriptionsLoading
}) => {
  const theme = useTheme();
  const { data: allOrgList, isLoading: orgListLoading } = useGetOrganizationNewAllList();
  // console.log('🚀 ~ allOrgList:', allOrgList);
  return (
    <>
      <Form noValidate onSubmit={handleSubmit}>
        <Grid container spacing={gridSpacing} sx={{ alignContent: 'center' }}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Grid
              container
              spacing={gridSpacing}
              sx={{ display: 'flex', flexDirection: { xs: 'column-reverse', sm: 'row', md: 'row', lg: 'row', xl: 'row' } }}
            >
              <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                <Typography variant="h4" component={'span'}>
                  Basic Details:
                </Typography>
              </Grid>
              {/* <Grid item xs={12} sm={4} md={4} lg={4} xl={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <FormGroup row>
                  <FormControlLabel
                    control={<Switch name="isPublic" checked={values?.isPublic} onChange={handleChange} onBlur={handleBlur} />}
                    label="Make this public"
                  />
                </FormGroup>
              </Grid> */}
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <FormControl sx={{ ...theme.typography.customInput }} error={Boolean(touched.name && errors.name)} fullWidth>
              <InputLabel htmlFor="outlined-name">Name *</InputLabel>
              <OutlinedInput
                id="outlined-name"
                type="text"
                name="name"
                label="Name *"
                onBlur={handleBlur}
                value={values.name}
                onChange={handleChange}
              />
              {touched.name && errors.name && (
                <FormHelperText sx={{ fontSize: '13.8px' }} error>
                  {errors.name}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <FormControl
              sx={{ ...theme.typography.customInput }}
              className="ticket_detailstextarea"
              error={Boolean(touched.description && errors.description)}
              fullWidth
            >
              <InputLabel htmlFor="outlined-description">Description *</InputLabel>
              <OutlinedInput
                id="outlined-description"
                type="text"
                name="description"
                label="Description *"
                onBlur={handleBlur}
                // multiline
                // rows={2}
                value={values.description}
                onChange={handleChange}
              />
              {touched.description && errors.description && (
                <FormHelperText error sx={{ fontSize: '13.8px' }}>
                  {errors.description}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <FormControl
              fullWidth
              sx={{ ...theme.typography.customInput }}
              error={Boolean(touched && errors && touched?.currencyCode && errors?.currencyCode)}
            >
              <InputLabel htmlFor="outlined-currencyCode">Currency Code *</InputLabel>
              <Select
                id="outlined-currencyCode"
                name="currencyCode"
                value={values.currencyCode}
                onChange={handleChange}
                onBlur={handleBlur}
                label="Currency Code *"
              >
                {!!currencyArray &&
                  Array.isArray(currencyArray) &&
                  currencyArray?.length &&
                  currencyArray.map((val, index) => (
                    <MenuItem value={val?.Code} key={index}>
                      {val?.Currency}&nbsp;({val?.Code})
                    </MenuItem>
                  ))}
              </Select>
              {touched && errors && touched?.currencyCode && errors?.currencyCode && (
                <FormHelperText
                  error
                  id="standard-weight-helper-text-email-title"
                  sx={{
                    fontSize: '13.8px'
                    // fontWeight: 500
                  }}
                >
                  {errors?.currencyCode}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={2} xl={2}>
            <FormControl sx={{ ...theme.typography.customInput }} error={Boolean(touched.tax && errors.tax)} fullWidth>
              <InputLabel htmlFor="outlined-tax">Tax *</InputLabel>
              <OutlinedInput
                id="outlined-tax"
                type="number"
                name="tax"
                label="Tax *"
                onBlur={handleBlur}
                value={values.tax}
                onChange={handleChange}
                endAdornment={
                  <InputAdornment position="end" sx={{ mt: 2 }}>
                    <span
                      style={{
                        fontSize: '0.9rem',
                        fontWeight: 400,
                        color: theme.palette.text.secondary
                      }}
                    >
                      %
                    </span>
                  </InputAdornment>
                }
              />
              {touched.tax && errors.tax && (
                <FormHelperText sx={{ fontSize: '13.8px' }} error>
                  {errors.tax}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={2} xl={2}>
            <FormControl sx={{ ...theme.typography.customInput }} error={Boolean(touched.localUser && errors.localUser)} fullWidth>
              <InputLabel htmlFor="outlined-local-user">Local User Count *</InputLabel>
              <OutlinedInput
                id="outlined-local-user"
                type="number"
                name="localUser"
                label="Local User Count *"
                onBlur={handleBlur}
                value={values.localUser}
                onChange={handleChange}
              />
              {touched.localUser && errors.localUser && (
                <FormHelperText sx={{ fontSize: '13.8px' }} error>
                  {errors.localUser}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={2} xl={2}>
            <FormControl sx={{ ...theme.typography.customInput }} error={Boolean(touched.globalUser && errors.globalUser)} fullWidth>
              <InputLabel htmlFor="outlined-global-user">Global User Count *</InputLabel>
              <OutlinedInput
                id="outlined-global-user"
                type="number"
                name="globalUser"
                label="Global User Count *"
                onBlur={handleBlur}
                value={values.globalUser}
                onChange={handleChange}
              />
              {touched.globalUser && errors.globalUser && (
                <FormHelperText sx={{ fontSize: '13.8px' }} error>
                  {errors.globalUser}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={2} xl={2}>
            <FormControl sx={{ ...theme.typography.customInput }} error={Boolean(touched.noOfAds && errors.noOfAds)} fullWidth>
              <InputLabel htmlFor="outlined-noOfAds">No. of Advertisements *</InputLabel>
              <OutlinedInput
                id="outlined-noOfAds"
                type="number"
                name="noOfAds"
                label="No. of Advertisements *"
                onBlur={handleBlur}
                value={values.noOfAds}
                onChange={handleChange}
              />
              {touched.noOfAds && errors.noOfAds && (
                <FormHelperText sx={{ fontSize: '13.8px' }} error>
                  {errors.noOfAds}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Divider />
          </Grid>

          {/* Regular Billings */}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Grid
              container
              spacing={gridSpacing}
              sx={{ display: 'flex', flexDirection: { xs: 'column-reverse', sm: 'row', md: 'row', lg: 'row', xl: 'row' } }}
            >
              <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                <Typography variant="h4" component={'span'}>
                  Regular Billings:
                </Typography>
              </Grid>
              {/* <Grid item xs={12} sm={4} md={4} lg={4} xl={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <FormGroup row>
                  <FormControlLabel
                    control={<Switch name="isPublic" checked={values?.isPublic} onChange={handleChange} onBlur={handleBlur} />}
                    label="Make this public"
                  />
                </FormGroup>
              </Grid> */}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <FormControl
              sx={{ ...theme.typography.customInput }}
              error={Boolean(touched.regularIntervalUnit && errors.regularIntervalUnit)}
              fullWidth
            >
              <InputLabel htmlFor="outlined-regularIntervalUnit">Trial Interval Unit *</InputLabel>
              <Select
                id="outlined-regularIntervalUnit"
                name="regularIntervalUnit"
                value={values.regularIntervalUnit}
                onChange={handleChange}
                onBlur={handleBlur}
                label="Trial Interval Unit *"
              >
                <MenuItem value="day">Day</MenuItem>
                <MenuItem value="week">Week</MenuItem>
                <MenuItem value="month">Month</MenuItem>
                <MenuItem value="year">Year</MenuItem>
              </Select>
              {touched.regularIntervalUnit && errors.regularIntervalUnit && (
                <FormHelperText sx={{ fontSize: '13.8px' }} error>
                  {errors.regularIntervalUnit}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <FormControl
              sx={{ ...theme.typography.customInput }}
              error={Boolean(touched.regularIntervalCount && errors.regularIntervalCount)}
              fullWidth
            >
              <InputLabel htmlFor="outlined-regularIntervalCount">Trial Interval Count *</InputLabel>
              <OutlinedInput
                id="outlined-regularIntervalCount"
                type="number"
                name="regularIntervalCount"
                label="regularIntervalCount *"
                onBlur={handleBlur}
                value={values.regularIntervalCount}
                onChange={handleChange}
              />
              {touched.regularIntervalCount && errors.regularIntervalCount && (
                <FormHelperText sx={{ fontSize: '13.8px' }} error>
                  {errors.regularIntervalCount}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <FormControl sx={{ ...theme.typography.customInput }} error={Boolean(touched.regularPrice && errors.regularPrice)} fullWidth>
              <InputLabel htmlFor="outlined-regularPrice">Price *</InputLabel>
              <OutlinedInput
                id="outlined-regularPrice"
                type="number"
                name="regularPrice"
                label="Price *"
                onBlur={handleBlur}
                value={values.regularPrice}
                onChange={handleChange}
                startAdornment={
                  <InputAdornment position="start" sx={{ mt: 2 }}>
                    <span
                      style={{
                        fontSize: '1rem',
                        fontWeight: 500,
                        color: theme.palette.text.secondary
                      }}
                    >
                      $
                    </span>
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end" sx={{ mt: 2 }}>
                    <span
                      style={{
                        fontSize: '0.9rem',
                        fontWeight: 400,
                        color: theme.palette.text.secondary
                      }}
                    >
                      /user per month
                    </span>
                  </InputAdornment>
                }
              />
              {touched.regularPrice && errors.regularPrice && (
                <FormHelperText sx={{ fontSize: '13.8px' }} error>
                  {errors.regularPrice}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Divider />
          </Grid>

          {/* Trial Period */}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Grid
              container
              spacing={gridSpacing}
              sx={{ display: 'flex', flexDirection: { xs: 'column-reverse', sm: 'row', md: 'row', lg: 'row', xl: 'row' } }}
            >
              <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                <Typography variant="h4" component={'span'}>
                  Trial Period (Optional):
                </Typography>
              </Grid>
              {/* <Grid item xs={12} sm={4} md={4} lg={4} xl={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <FormGroup row>
                  <FormControlLabel
                    control={<Switch name="isPublic" checked={values?.isPublic} onChange={handleChange} onBlur={handleBlur} />}
                    label="Make this public"
                  />
                </FormGroup>
              </Grid> */}
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <FormControl
              sx={{ ...theme.typography.customInput }}
              error={Boolean(touched.trialIntervalUnit && errors.trialIntervalUnit)}
              fullWidth
            >
              <InputLabel htmlFor="outlined-trialIntervalUnit">Trial Interval Unit *</InputLabel>
              <Select
                id="outlined-trialIntervalUnit"
                name="trialIntervalUnit"
                value={values.trialIntervalUnit}
                onChange={handleChange}
                onBlur={handleBlur}
                label="Trial Interval Unit *"
              >
                <MenuItem value="day">Day</MenuItem>
                <MenuItem value="week">Week</MenuItem>
                <MenuItem value="month">Month</MenuItem>
                <MenuItem value="year">Year</MenuItem>
              </Select>
              {touched.trialIntervalUnit && errors.trialIntervalUnit && (
                <FormHelperText sx={{ fontSize: '13.8px' }} error>
                  {errors.trialIntervalUnit}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <FormControl
              sx={{ ...theme.typography.customInput }}
              error={Boolean(touched.trialIntervalCount && errors.trialIntervalCount)}
              fullWidth
            >
              <InputLabel htmlFor="outlined-trialIntervalCount">Trial Interval Count *</InputLabel>
              <OutlinedInput
                id="outlined-trialIntervalCount"
                type="number"
                name="trialIntervalCount"
                label="trialIntervalCount *"
                onBlur={handleBlur}
                value={values.trialIntervalCount}
                onChange={handleChange}
              />
              {touched.trialIntervalCount && errors.trialIntervalCount && (
                <FormHelperText error>{errors.trialIntervalCount}</FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
            <FormControl sx={{ ...theme.typography.customInput }} error={Boolean(touched.trialPrice && errors.trialPrice)} fullWidth>
              <InputLabel htmlFor="outlined-price">Price *</InputLabel>
              <OutlinedInput
                id="outlined-price"
                type="number"
                name="trialPrice"
                label="Price *"
                onBlur={handleBlur}
                value={values.trialPrice}
                onChange={handleChange}
                startAdornment={
                  <InputAdornment position="start" sx={{ mt: 2 }}>
                    <span
                      style={{
                        fontSize: '1rem',
                        fontWeight: 500,
                        color: theme.palette.text.secondary
                      }}
                    >
                      $
                    </span>
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end" sx={{ mt: 2 }}>
                    <span
                      style={{
                        fontSize: '0.9rem',
                        fontWeight: 400,
                        color: theme.palette.text.secondary
                      }}
                    >
                      /user per month
                    </span>
                  </InputAdornment>
                }
              />
              {touched.trialPrice && errors.trialPrice && (
                <FormHelperText sx={{ fontSize: '13.8px' }} error>
                  {errors.trialPrice}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Divider />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography variant="h4" component={'span'}>
              Add Features:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <FieldArray
              name="features"
              render={(arrayHelpers) => (
                <Grid container spacing={{ xs: 1, sm: 1, md: 1, lg: gridSpacing, xl: gridSpacing }} alignItems="center">
                  {values.features.map((feature, index) => (
                    <Fragment key={index}>
                      <Grid item xs={12} sm={12} md={12} lg={9} xl={9}>
                        <FormControl
                          sx={{ ...theme.typography.customInput }}
                          error={Boolean(touched.features?.[index] && errors.features?.[index])}
                          fullWidth
                        >
                          <InputLabel htmlFor={`feature-${index}`}>Feature *</InputLabel>
                          <OutlinedInput
                            id={`feature-${index}`}
                            type="text"
                            name={`features[${index}]`}
                            label={`Feature *`}
                            value={feature}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {touched.features?.[index] && errors.features?.[index] && (
                            <FormHelperText sx={{ fontSize: '13.8px' }} error>
                              {errors.features?.[index]}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={3} xl={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Grid
                          container
                          spacing={{ xs: 1, sm: 1, md: 1, lg: gridSpacing, xl: gridSpacing }}
                          alignItems="center"
                          sx={{ display: 'flex', justifyContent: 'flex-end' }}
                        >
                          {/* Show "Add" button for the last element */}
                          {index === values.features.length - 1 && (
                            <Grid item xs={6} sm={4} md={3} lg={6} xl={6}>
                              <Button
                                color="success"
                                fullWidth
                                variant="outlined"
                                onClick={() => arrayHelpers.push('')}
                                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                                endIcon={<ControlPointIcon color="success" />}
                              >
                                Add
                              </Button>
                            </Grid>
                          )}

                          <Grid item xs={6} sm={4} md={3} lg={6} xl={6}>
                            <Button
                              disabled={values.features.length < 2}
                              fullWidth
                              variant="outlined"
                              color="error"
                              onClick={() => arrayHelpers.remove(index)}
                              sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                              endIcon={<RemoveCircleOutlineIcon color={values.features.length < 2 ? 'disabled' : 'error'} />}
                            >
                              Remove
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                      {values.features.length > 1 && (
                        <Grid item xs={12} sm={12}>
                          <Divider />
                        </Grid>
                      )}
                    </Fragment>
                  ))}
                </Grid>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {/* <Grid item xs={12}>
              <Grid container spacing={gridSpacing}> */}
            <FormGroup row>
              <FormControlLabel
                label="Custom Subscription Plan"
                control={<Switch name="isSwitch" onBlur={handleBlur} checked={values?.isSwitch} onChange={handleChange} />}
              />
            </FormGroup>
            {values?.isSwitch && (
              <>
                <Grid
                  container
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  xl={6}
                  className="select-job-enterprise select-job-enterprise-type-machine-filter"
                >
                  <Typography variant="h6" style={{ fontSize: '15px', fontWeight: '600', paddingBottom: '5px' }}>
                    Organization Name
                  </Typography>
                  <Autocomplete
                    multiple
                    fullWidth
                    options={allOrgList?.data || []}
                    getOptionLabel={(option) => option.name ?? ''}
                    value={allOrgList?.data?.filter((item) => values?.assignedOrgs?.includes(item.id)) || []}
                    onChange={(event, newValue) => {
                      const selectedIds = newValue.map((item) => item.id);
                      handleChange({ target: { name: 'assignedOrgs', value: selectedIds } });
                    }}
                    onBlur={handleBlur}
                    renderTags={(value, getTagProps) =>
                      value?.map((option, index) => {
                        const { onDelete, ...tagProps } = getTagProps({ index });
                        return (
                          <span
                            key={option.id}
                            {...tagProps}
                            style={{
                              backgroundColor: '#6fd74b',
                              color: '#fff',
                              padding: '2px 8px',
                              borderRadius: '4px',
                              marginRight: '5px',
                              display: 'flex',
                              alignItems: 'center'
                            }}
                          >
                            {option.name}
                            <button
                              onClick={onDelete}
                              style={{
                                marginLeft: '5px',
                                background: 'none',
                                border: 'none',
                                color: '#fff',
                                cursor: 'pointer'
                              }}
                              type="button"
                            >
                              ✖
                            </button>
                          </span>
                        );
                      })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Search and Select Organizations"
                        name="assignedOrgs"
                        error={touched?.assignedOrgs && Boolean(errors?.assignedOrgs)}
                        // helperText={touched?.assignedOrgs && errors?.assignedOrgs}
                        // helperText={
                        //   touched?.assignedOrgs && errors?.assignedOrgs ? (
                        //     <span style={{ fontSize: '12px' }}>{errors.assignedOrgs}</span>
                        //   ) : null
                        // }
                      />
                    )}
                    loading={orgListLoading}
                    PaperComponent={(props) => <Paper {...props} />}
                  />
                  {touched.assignedOrgs && errors.assignedOrgs && (
                    <FormHelperText
                      error
                      id="standard-weight-helper-text-first-name"
                      sx={{
                        fontSize: '13.8px',
                        marginLeft: '12px'
                      }}
                    >
                      {errors.assignedOrgs}
                    </FormHelperText>
                  )}
                </Grid>
              </>
            )}
            {/* </Grid>
            </Grid> */}
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <FormLabel>Add Plan Color</FormLabel>
            <div style={{ marginTop: 18, width: '100%', height: '100%' }}>
              <ColorPicker
                // height={150}
                // hideInput={['rgb', 'hsv']}
                color={values?.planColor}
                onChange={(color) => setFieldValue('planColor', color)}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <FormLabel>Preview</FormLabel>
            <Paper sx={{ p: 6, borderRadius: 2, boxShadow: 3, height: '100%' }} style={{ marginTop: 18 }}>
              <div className="subcription-content">
                <Typography variant="h2" align="left" sx={{ fontWeight: '600' }}>
                  {values?.name || 'The Plan name'}
                </Typography>
                <Typography variant="body2" align="left" sx={{ mb: 2, pt: 2 }}>
                  {values?.description || 'The Plan Description'}
                </Typography>
                <Typography variant="h1" align="left" sx={{ fontWeight: '700', mb: 2 }}>
                  ${values?.price || '0.00'}{' '}
                  <span style={{ fontSize: '12.5px', color: '#a4a4a4', fontWeight: '500' }}>/{values?.interval}</span>
                </Typography>
                <Typography variant="h4" align="left" sx={{ fontWeight: '600' }}>
                  {values?.localUser || 0} Machine Specific User(s) and {values?.globalUser || 0} Global User(s) with{' '}
                  {values?.noOfAds ? values?.noOfAds + ' Advertisements' : 'No Advertisements'}
                </Typography>
                {values?.isSwitch && (
                  <Chip
                    className="stats_var"
                    label={'Custom Subscription Plan'}
                    sx={{
                      borderRadius: '4px', // Customize the border radius here
                      backgroundColor: '#6fd74b',
                      color: '#fff',
                      fontWeight: '500',
                      marginTop: '6px'
                      // marginLeft: '20px'
                    }}
                  />
                )}
                {Array.isArray(values?.features) && values.features.some((feature) => feature.trim()) ? (
                  <List sx={{ paddingTop: 5 }}>
                    {values.features
                      .filter((feature) => typeof feature === 'string' && feature.trim()) // Ensure valid, non-empty strings
                      .map((feature, index) => (
                        <ListItem key={index} sx={{ paddingLeft: 0 }}>
                          <ListItemIcon>
                            <CheckIcon
                              sx={{
                                color: values?.planColor?.hex
                                // fontWeight: '800'
                              }}
                              // color="secondary"
                            />
                          </ListItemIcon>
                          <ListItemText
                            sx={{
                              // color: '#FFBF00',
                              fontWeight: '800'
                            }}
                            primary={feature}
                          />
                          {/* <Typography variant="h5" component={'span'} style={{ fontWeight: 'bold' }}>
                          {feature}
                        </Typography> */}
                        </ListItem>
                      ))}
                  </List>
                ) : (
                  <List sx={{ paddingTop: 5 }}>
                    {[1, 2, 3, 4].map((index) => (
                      <ListItem key={index} sx={{ paddingLeft: 0 }}>
                        <ListItemIcon>
                          <CheckIcon
                            sx={{
                              color: values?.planColor?.hex
                              // fontWeight: '500'
                            }}
                            // color="secondary"
                          />
                        </ListItemIcon>
                        {/* <ListItemText
                        sx={{
                          // color: '#FFBF00',
                          fontWeight: '800'
                        }}
                        primary={'Listed Feature ' + index}
                      /> */}
                        <Typography variant="h5" component={'span'} style={{ fontWeight: '600' }}>
                          {'Listed Feature ' + index}
                        </Typography>
                      </ListItem>
                    ))}
                  </List>
                )}
              </div>
              <Button
                type="button"
                variant="contained"
                color="primary"
                fullWidth
                sx={{
                  mt: 4,
                  p: 2,
                  color: '#FFF',
                  backgroundColor: values?.planColor?.hex,
                  '&:hover': {
                    backgroundColor: values?.planColor?.hex
                  },
                  fontSize: '1rem',
                  boxShadow: 'none'
                }}
                // onClick={callInvoiceScreen}
              >
                Select Plan
              </Button>
            </Paper>
          </Grid>

          <Grid item xs={12}>
            {errors.submit && (
              <Box sx={{ mt: 3 }}>
                <FormHelperText error>{errors.submit}</FormHelperText>
              </Box>
            )}
            <Box sx={{ mt: 5, justifyContent: 'center', textAlign: 'center' }}>
              <AnimateButton>
                <Button
                  disableElevation
                  disabled={isSubscriptionsLoading}
                  size="large"
                  type="submit"
                  variant="contained"
                  color="secondary"
                  style={{
                    color: 'white',
                    minWidth: '200px',
                    margin: '0px auto'
                  }}
                >
                  {isSubscriptionsLoading ? (
                    <CircularProgress
                      sx={{
                        color: 'white',
                        height: 20,
                        width: 20
                      }}
                    />
                  ) : (
                    'Submit'
                  )}
                </Button>
              </AnimateButton>
            </Box>
          </Grid>
        </Grid>
      </Form>
    </>
  );
};

SubscriptionForm.propTypes = {
  touched: PropTypes.object,
  values: PropTypes.object,
  errors: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  setFieldValue: PropTypes.func
};

export default SubscriptionForm;
